import { Link, SimpleCallback, Tabs, Text } from 'platform-components';
import React from 'react';

import { LibraryTabView } from './library__tabs-view';

interface Props {
    tab: LibraryTabView;
    selected: boolean;
    onClick: SimpleCallback;
}

const LibraryTabLink = ({ tab, onClick, selected }: Props) => {
    return (
        <Link mix="library__tabs-link" onClick={onClick} theme={Link.THEME.INHERIT}>
            <Tabs.Tab id={tab.slug} mix="library__tab" selected={selected}>
                <Text type={Text.TYPE.MARKDOWN}>{tab.name}</Text>
            </Tabs.Tab>
        </Link>
    );
};

export default LibraryTabLink;
